<div class="container">
  <div class="row">
    <div class="col-md-10 m-auto">
      <div [innerHTML]="content"></div>
    </div>
  </div>
</div>
